module.exports = "<div class=\"container\" [hidden]=\"isHidden\">\r\n  <img src=\"../../../assets/img/breadcrumb_vehicles.png\">\r\n  <ol class=\"breadcrumb\">\r\n    <li><a routerLink=\"\" class=\"gray-text\">Home</a></li>\r\n    <li *ngFor=\"let breadcrumb of breadcrumbs\">\r\n      <a [ngClass]=\"isLastBreadcrumb(breadcrumb) ? 'text-primary' : 'gray-text'\" [routerLink]=\"[breadcrumb.url, breadcrumb.params]\">{{ breadcrumb.label }}</a>\r\n    </li>\r\n  </ol>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/breadcrumb/breadcrumb.component.html
// module id = ./src/app/breadcrumb/breadcrumb.component.html
// module chunks = main